module.exports = __webpack_public_path__ + "static/img/game-logo-playstar.84d9c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-playstar.png
// module id = Ao2L
// module chunks = 0 1 2 3 4 5 6